import { Box, Heading, HStack, PopoverHeader, Text } from '@chakra-ui/react';
import moment from 'moment';
import { i18n } from '@investigator/shared/localization';
import { useEntitiesContext } from '../../context';
import { SkeletonLoader } from '../SkeletonLoader';

const { malicious, published } = i18n.pages.entityDetails;

enum DATA_TEST_IDS {
  DetailsHeader = 'entity-information-trigger-details-header',
  HeadingEntityName = 'heading-entity-name',
  MaliciousLabel = 'entity-information-trigger-malicious-label',
  MaliciousConfidence = 'entity-information-trigger-malicious-confidence',
  PublishedDate = 'entity-information-trigger-published-date',
}

export const EntityPopoverHeader = (): JSX.Element => {
  const { selectedEntity } = useEntitiesContext();

  // Get IOC data from selectedEntity
  const entityName = selectedEntity?.entityName || '';
  const iocMaliciousConfidence =
    selectedEntity?.logscaleMetaData?.['ioc[0].malicious_confidence'];
  const iocPublishedDate = selectedEntity?.logscaleMetaData?.[
    'ioc[0].published_date'
  ]
    ? String(selectedEntity.logscaleMetaData['ioc[0].published_date'])
    : undefined;
  const isLoadingIOC = selectedEntity?.logscaleMetaData === undefined;

  return (
    <PopoverHeader data-testid={DATA_TEST_IDS.DetailsHeader}>
      <Heading
        textStyle="body-md-bold"
        data-testid={DATA_TEST_IDS.HeadingEntityName}
      >
        {entityName}
      </Heading>
      <HStack w="100%">
        {isLoadingIOC ? (
          <Box w="100%">
            <SkeletonLoader rowCount={1} />
          </Box>
        ) : (
          <>
            {iocMaliciousConfidence && (
              <>
                <Text
                  bg="red.800"
                  color="red.200"
                  borderRadius="md"
                  data-testid={DATA_TEST_IDS.MaliciousLabel}
                >
                  {`${malicious}`}
                </Text>
                <Text
                  bg="red.800"
                  color="red.200"
                  borderRadius="md"
                  textTransform="capitalize"
                  data-testid={DATA_TEST_IDS.MaliciousConfidence}
                >
                  {`${iocMaliciousConfidence}`}
                </Text>
              </>
            )}
            {iocPublishedDate && (
              <Text
                bg="blue.800"
                color="blue.200"
                borderRadius="md"
                data-testid={DATA_TEST_IDS.PublishedDate}
              >{`${published} ${moment(Number(iocPublishedDate)).format('MMMM D, YYYY')}`}</Text>
            )}
          </>
        )}
      </HStack>
    </PopoverHeader>
  );
};
